/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import FormControl from '@mui/joy/FormControl';
import FormLabel from '@mui/joy/FormLabel';
import FormHelperText from '@mui/joy/FormHelperText';
import { Box } from '@mui/joy';
import TextField from '@mui/material/TextField';

interface Props {
  id?: string;
  hidden?: boolean;
  tooltip?: string;
  mdCol?: string;
  label?: string;
  name: string;
  values: any;
  onChange?: (e: any) => void;
  isValid?: boolean;
  feedback?: any;
  placeholder?: string;
  disabled?: boolean;
  countText?: number;
  isOverCount?: boolean;
  rows?: number;
  className?: string;
  countWord?: number;
  maxLength?: number;
  logo?: string;
  isMissing?: any;
  isCMLogo?: boolean;
  setLabelHight?: boolean;
  isTestCsuLogo?: boolean;
  isCuScuLogo?: boolean;
}

const TextAreaInput = (props: Props) => {
  const [counter, setCounter] = React.useState(0);
  const [counterWord, setCounterWord] = React.useState(0);
  const [classOverText, setClassOverText] = React.useState('');

  const changeColorOverCount = () => {
    let newClassOverText = '';
    
    // Kiểm tra vượt quá giới hạn ký tự
    if (props.isOverCount && props.countText && (props.values?.length ?? 0) > props.countText) {
      newClassOverText = 'text-danger';
    }

    // Kiểm tra vượt quá giới hạn từ
    if (props.isOverCount && props.countWord && ((props.values || '').split(/\s+/).filter(Boolean).length ?? 0) > props.countWord) {
      newClassOverText = 'text-danger';
    }

    setClassOverText(newClassOverText);
  };

  const getInfo = () => {
    const wordCount = (props.values || '').split(/\s+/).filter(Boolean).length;
    
    // Set character counter
    if (props.countText) {
      setCounter(props.values?.length ?? 0);
    }
    
    // Set word counter
    if (props.countWord) {
      setCounterWord(wordCount ?? 0);
    }
    
    changeColorOverCount();
  };
  React.useEffect(() => {
    getInfo();
  }, [props.values]);

  React.useEffect(() => {
    changeColorOverCount();
  }, []);

  // Thêm useEffect để theo dõi thay đổi của isOverCount
  React.useEffect(() => {
    changeColorOverCount();
  }, [props.isOverCount, props.countText, props.countWord]);

  /**
   * Hàm thay đổi giá trị của Textarea
   * Nếu có giới hạn ký tự (props.countText) và không cho phép vượt quá giới hạn (props.isOverCount = false) thì không cho phép thay đổi
   * Nếu có giới hạn số lượng từ (props.countWord) và không cho phép vượt quá giới hạn (props.isOverCount = false) thì không cho phép thay đổi
   * Nếu có giới hạn số lượng từ và đang ở tại vị trí cuối cùng của Textarea và bấm phím " " (dấu space) thì không cho phép thay đổi
   * @param {React.ChangeEvent<HTMLTextAreaElement>} e sự kiện thay đổi giá trị của Textarea
   */
  const handleChange = async (e: any) => {
    try {
      // Nếu isOverCount = false, không cho phép vượt quá giới hạn
      if (!props.isOverCount) {
        if (props.countText && e.target.value.length > props.countText) {
          return;
        }

        // Đếm số lượng "từ" còn lại sau khi lọc
        const wordCount = (e.target.value || '').split(/\s+/).filter(Boolean).length;
        if (props.countWord && wordCount > props.countWord) return;

        // prevent add more space
        if (props.countWord && wordCount === props.countWord) {
          if (e.target.value[e.target.value.length - 1] === ' ') return;
        }
      }

      props.onChange && props.onChange(e);
    } catch (ex) {
      console.log('Error:', ex);
    }
  };

  if (props.hidden) return null;

  return (
    <FormControl
      id={props.id} // this id used to generate id for label, input... inside FormControl
      disabled={props.disabled}
      error={!!props.isMissing}
      className={props.className}
    >
      {props.label && (
        <div
          style={
            props.setLabelHight
              ? {
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  minHeight: '40px',
                }
              : { marginBottom: '2px' }
          }
        >
          <FormLabel
            // className={`select-label label-14px`}
            className={`label-14px pb-1 ${props.logo ?? ''}`.trim()}
            sx={{
              display: 'flex',
              alignItems: 'center',
              fontSize: '14px',
              margin: props.setLabelHight ? 0 : undefined,
              marginBottom: '1px !important',
              backgroundColor: props.isMissing ? '#FFEBEB' : '',
              width: 'calc(100% + 4px)',
            }}
          >
            {props.label}
            {/* <span>{props.label}</span> */}
            {/* {(props?.logo && props.setLabelHight) && (
              <FormLabel className={`csu-logo-select-input-float-right ${props?.logo ?? ''}`.trim()} />
            )} */}
          </FormLabel>
          {/* {(props?.logo && !props.setLabelHight && !props.isTestCsuLogo && !props.isCuScuLogo) ? <span className={`cm-logo-select-input-float-right ${props?.logo ?? null}`}></span> : null} */}
          {(props?.logo && props.isTestCsuLogo) ? <span className={`csu-logo-sat-text-float-right ${props?.logo ?? null}`}></span> : null}
          {(props?.logo && props.isCuScuLogo) ? <span className={`csu-logo-cu-csu-citizen-right ${props?.logo ?? null}`}></span> : null}
        </div>
      )}
      
      {!props.label && props.logo && (
        <div
          style={
            props.setLabelHight
              ? {
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'flex-end',
                  minHeight: '40px',
                }
              : { marginBottom: '2px' }
          }
        >
          {(props?.logo && !props.setLabelHight && !props.isTestCsuLogo && !props.isCuScuLogo) ? <span className={`cm-logo-select-input-float-right ${props?.logo ?? null}`}></span> : null}
          {(props?.logo && props.isTestCsuLogo) ? <span className={`csu-logo-sat-text-float-right ${props?.logo ?? null}`}></span> : null}
          {(props?.logo && props.isCuScuLogo) ? <span className={`csu-logo-cu-csu-citizen-right ${props?.logo ?? null}`}></span> : null}
        </div>
      )}
      
      {props.tooltip && (
        <Box 
          className="text-field-light"
          sx={{ 
            fontSize: '0.8rem',
            marginBottom: '8px',
            color: 'text.secondary'
          }}
        >
          {props.tooltip}
        </Box>
      )}
      
      <TextField
        id={props.id} // real id here
        className={classOverText}
        placeholder={props.placeholder}
        disabled={props.disabled}
        name={props.name}
        value={props.values ?? ''}
        onChange={handleChange}
        multiline
        rows={props.rows || 3}
        inputProps={{
          maxLength: props.isOverCount ? undefined : props.countText,
        }}
        sx={{
          fontSize: '15px',
          backgroundColor: '#fff',
          marginTop: '4px',
          '& .MuiOutlinedInput-root': {
            fontSize: '15px',
            backgroundColor: '#fff',
          },
          '& .MuiInputBase-inputMultiline': {
            resize: 'both',
          },
          '&.text-danger .MuiOutlinedInput-root': {
            '& .MuiOutlinedInput-input': {
              color: '#d32f2f !important',
            },
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#d32f2f !important',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#d32f2f !important',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#d32f2f !important',
            }
          }
        }}
        error={!!props.isMissing}
        color={props.isValid ? 'success' : undefined}
      />
      {(props.countText || props.countWord) && (
      <FormHelperText 
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between', 
          width: '100%', 
          minHeight: '1rem',
          fontSize: '0.875rem',
          color: 'text.secondary'
        }}
      >
        <span>{props.feedback}</span>
        <Box sx={{ display: 'flex', gap: 2 }}>
          {props.countText && (
            <span 
              title={`${counter}/${props.countText} characters`}
              style={{
                color: props.isOverCount && counter > props.countText ? '#d32f2f' : 'inherit'
              }}
            >
              {counter}/{props.countText} characters
            </span>
          )}
          {props.countWord && (
            <span 
              title={`${counterWord}/${props.countWord} words`}
              style={{
                color: props.isOverCount && counterWord > props.countWord ? '#d32f2f' : 'inherit'
              }}
            >
              {counterWord}/{props.countWord} words
            </span>
          )}
        </Box>
      </FormHelperText>
      )}
    </FormControl>
  );
};

export default TextAreaInput;
